import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegistrationComponent } from './registration/registration.component';
import { AuthGuard } from './core/services/auth/auth-guard-service.guard';
import { SkipRegisterGuard } from './core/services/auth/skip-register.guard';

import { BilDashboardComponent } from './home/bil-dashboard/bil-dashboard.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'registration',
    pathMatch: 'full'
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then(module => module.RegistrationModule),
    canLoad: [SkipRegisterGuard]
  },
  {
    path: 'bil',
    loadChildren: () => import('./home/home.module').then(module => module.HomeModule),
  },
  { path: 'dashboard', component: BilDashboardComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
